/**
 * The numbers behind the customer-facing step counter: "Step 2 of 4" under the V1 progress
 * dots and "Step 2/4" in the V2 header. Both read them from here so they cannot disagree.
 *
 * `currentStep` is an indexOf result upstream, so it is clamped rather than allowed to print
 * "Step 0 of 4" on the frame before a step is set.
 *
 * @param {Object} options - Options object.
 * @param {number} options.currentStep - Current step index (-1 when no step is set yet).
 * @param {number} options.totalSteps - Total number of steps.
 * @returns {{ currentStepNumber: number, totalSteps: number }} The 1-based current step and the total.
 */
export function getStepCount({ currentStep, totalSteps }) {
  const currentStepNumber = Math.min(Math.max(currentStep + 1, 1), totalSteps);
  return { currentStepNumber, totalSteps };
}
